export default __webpack_public_path__ + "static/media/flag-mozambique.dfdd4ce4.svg";